






























































































































































































































































































import Vue from 'vue';
import { TCollectionIcons, TDropDownList, typeDevice } from '@/types';
import publisherIcons from './publisherIcons';
import FieldInput from '@/components/form/FieldInput.vue';
import FieldSelect from '@/components/form/FieldSelect.vue';
import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
import {
  EPosition,
  ETimeout,
  ETrigger,
  IWidgetParams,
} from '@/types/publisher/inventory';
import { TranslateResult } from 'vue-i18n';

const OPEN_TIMEOUTS: TDropDownList = [
  {
    label: '1 second',
    value: ETimeout.T_1,
  },
  {
    label: '5 seconds',
    value: ETimeout.T_5,
  },
  {
    label: '10 seconds',
    value: ETimeout.T_10,
  },
  {
    label: '30 seconds',
    value: ETimeout.T_30,
  },
];

const CLOSE_TIMEOUTS: TDropDownList = [
  {
    label: '10 second',
    value: ETimeout.T_10,
  },
  {
    label: '20 seconds',
    value: ETimeout.T_20,
  },
  {
    label: '30 seconds',
    value: ETimeout.T_30,
  },
  {
    label: '60 seconds',
    value: ETimeout.T_60,
  },
];

const DESKTOP_POSITIONS: TDropDownList = [
  {
    label: 'Top Right',
    value: EPosition.TOP_RIGHT,
  },
  {
    label: 'Top Left',
    value: EPosition.TOP_LEFT,
  },
  {
    label: 'Bottom Right',
    value: EPosition.BOTTOM_RIGHT,
  },
  {
    label: 'Bottom Left',
    value: EPosition.BOTTOM_LEFT,
  },
];
const MOBILE_POSITIONS: TDropDownList = [
  {
    label: 'Top',
    value: EPosition.TOP_RIGHT,
  },
  {
    label: 'Bottom',
    value: EPosition.BOTTOM_RIGHT,
  },
];

const OPEN_TRIGGERS: TDropDownList = [
  { label: 'Timeout', value: ETrigger.TIMEOUT },
  { label: 'Scroll anchor (html id of element)', value: ETrigger.ANCHOR_ID },
  {
    label: 'Scroll anchor (html class of element)',
    value: ETrigger.ANCHOR_CLASS,
  },
  { label: 'Scroll (percent of page)', value: ETrigger.SCROLL },
];

const CLOSE_TRIGGERS: TDropDownList = [
  { label: 'Timeout', value: ETrigger.TIMEOUT },
  { label: 'Scroll (percent of page)', value: ETrigger.SCROLL },
];

const DEVICE_TYPES: TDropDownList = [
  { label: 'Mobile', value: typeDevice.MOBILE },
  { label: 'Tablet', value: typeDevice.TABLET },
  { label: 'Desktop', value: typeDevice.DESKTOP },
];

export default Vue.extend({
  name: 'PlacementTypePush',
  components: { FieldInput, FieldSelect, FieldCheckbox },
  props: {
    placementId: {
      type: String,
      required: true,
    },
  },
  computed: {
    widgetParams(): IWidgetParams {
      return this.$store.getters['publisher/getPlacementWidgetParams'].byId[
        this.placementId
      ];
    },
    publisherIcons(): TCollectionIcons {
      return publisherIcons;
    },
    positions(): TDropDownList {
      if (this.widgetParams.typeDevice === typeDevice.MOBILE) {
        return MOBILE_POSITIONS;
      }
      return DESKTOP_POSITIONS;
    },
    openTimeouts(): TDropDownList {
      return OPEN_TIMEOUTS;
    },
    closeTimeouts(): TDropDownList {
      return CLOSE_TIMEOUTS;
    },
    openTriggers(): TDropDownList {
      return OPEN_TRIGGERS;
    },
    closeTriggers(): TDropDownList {
      return CLOSE_TRIGGERS;
    },
    deviceTypes(): TDropDownList {
      return DEVICE_TYPES;
    },
    isMobileTypeDevice(): boolean {
      return this.widgetParams.typeDevice === typeDevice.MOBILE;
    },
    isOpenTriggerTimeout(): boolean {
      return this.widgetParams.openTriggerType === ETrigger.TIMEOUT;
    },
    isOpenTriggerAnchor(): boolean {
      return (
        this.widgetParams.openTriggerType === ETrigger.ANCHOR_ID ||
        this.widgetParams.openTriggerType === ETrigger.ANCHOR_CLASS
      );
    },
    isOpenTriggerScroll(): boolean {
      return this.widgetParams.openTriggerType === ETrigger.SCROLL;
    },
    isCloseTriggerTimeout(): boolean {
      return this.widgetParams.closeTriggerType === ETrigger.TIMEOUT;
    },
    isCloseTriggerScroll(): boolean {
      return this.widgetParams.closeTriggerType === ETrigger.SCROLL;
    },
    anchorPlaceholder(): TranslateResult {
      return this.widgetParams.openTriggerType === ETrigger.ANCHOR_ID
        ? this.$t(
            'pages.inventoryForm.blocks.createPlacement.anchorIdPlaceholder'
          )
        : this.$t(
            'pages.inventoryForm.blocks.createPlacement.anchorClassPlaceholder'
          );
    },
  },
  methods: {
    changeOpenTrigger(openTriggerType): void {
      let openTriggerValue = '';

      if (openTriggerType === ETrigger.TIMEOUT) {
        openTriggerValue = ETimeout.T_5;
      }

      this.changeEvent('openTriggerType', openTriggerType);
      this.changeEvent('openTriggerValue', openTriggerValue);
    },
    changeCloseTrigger(closeTriggerType): void {
      let closeTriggerValue = '';

      if (closeTriggerType === ETrigger.TIMEOUT) {
        closeTriggerValue = ETimeout.T_10;
      }

      this.changeEvent('closeTriggerType', closeTriggerType);
      this.changeEvent('closeTriggerValue', closeTriggerValue);
    },
    changeTypeDevice(typeDevice): void {
      this.changeEvent('typeDevice', typeDevice);
      this.changeEvent('position', EPosition.TOP_RIGHT);
    },
    changeEvent(propName: string, value: any): void {
      const newDataWithId = {
        id: this.placementId,
        propName,
        value,
      };

      this.$store.dispatch(
        'publisher/updatePlacementWidgetParamsData',
        newDataWithId
      );
    },
  },
});
